interface IconProps {
  color?: string
}

export const LightMode = ({ color }: IconProps) => {
  return (
    <svg
      width="32"
      height="32"
      aria-hidden="true"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0003 25.3337C16.5158 25.3337 16.9339 25.7518 16.9339 26.2673V28.4001C16.9339 28.9155 16.5158 29.3337 16.0003 29.3337C15.4849 29.3336 15.0667 28.9155 15.0667 28.4001V26.2673C15.0667 25.7518 15.4849 25.3337 16.0003 25.3337Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M8.08105 22.6006C8.44554 22.2361 9.03558 22.2361 9.40006 22.6006C9.7645 22.9651 9.76454 23.5551 9.40006 23.9196L7.89225 25.4287C7.52778 25.7931 6.93642 25.7931 6.57194 25.4287C6.20747 25.0642 6.2075 24.4729 6.57194 24.1084L8.08105 22.6006Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M22.6006 22.6006C22.9651 22.2361 23.5551 22.2361 23.9196 22.6006L25.4287 24.1084C25.7931 24.4729 25.7932 25.0642 25.4287 25.4287C25.0642 25.7931 24.4729 25.7931 24.1084 25.4287L22.6006 23.9196C22.2361 23.5551 22.2362 22.9651 22.6006 22.6006Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0003 9.33366C19.6822 9.33366 22.667 12.3184 22.667 16.0003C22.667 19.6822 19.6822 22.667 16.0003 22.667C12.3184 22.667 9.33366 19.6822 9.33366 16.0003C9.33366 12.3184 12.3184 9.33366 16.0003 9.33366ZM16.0003 11.0667C13.2757 11.0667 11.0667 13.2757 11.0667 16.0003C11.0667 18.7249 13.2757 20.9339 16.0003 20.9339C18.7249 20.9339 20.9339 18.7249 20.9339 16.0003C20.9339 13.2757 18.7249 11.0667 16.0003 11.0667Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M5.7334 15.0667C6.24886 15.0667 6.66699 15.4849 6.66699 16.0003C6.66699 16.5158 6.24886 16.9339 5.7334 16.9339H3.60059C3.08512 16.9339 2.66699 16.5158 2.66699 16.0003C2.66699 15.4849 3.08512 15.0667 3.60059 15.0667H5.7334Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M28.4001 15.0667C28.9155 15.0667 29.3337 15.4849 29.3337 16.0003C29.3337 16.5158 28.9155 16.9339 28.4001 16.9339H26.2673C25.7518 16.9339 25.3337 16.5158 25.3337 16.0003C25.3337 15.4849 25.7518 15.0667 26.2673 15.0667H28.4001Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M6.57194 6.57194C6.93637 6.20751 7.52775 6.20762 7.89225 6.57194L9.40137 8.08105C9.76522 8.4454 9.76516 9.03568 9.40137 9.40006C9.03688 9.76455 8.44554 9.76455 8.08105 9.40006L6.57194 7.89225C6.20765 7.52778 6.20761 6.93638 6.57194 6.57194Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M24.1084 6.57194C24.4729 6.20751 25.0642 6.20753 25.4287 6.57194C25.7932 6.93642 25.7932 7.52776 25.4287 7.89225L23.9196 9.40006C23.5551 9.76455 22.9651 9.76455 22.6006 9.40006C22.2362 9.03557 22.2361 8.44552 22.6006 8.08105L24.1084 6.57194Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M16.0003 2.66699C16.5158 2.66699 16.9339 3.08512 16.9339 3.60059V5.7334C16.9339 6.24886 16.5158 6.66699 16.0003 6.66699C15.4849 6.66696 15.0667 6.24884 15.0667 5.7334V3.60059C15.0667 3.08514 15.4849 2.66703 16.0003 2.66699Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
